var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 0L0 39.6889H16.3978H32.7968L16.3978 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7415 20.2001L23.2367 18.9668L16.4077 25.6384L17.3447 26.4569L22.7897 21.1285L28.215 34.2643L29.3528 33.7915L23.7415 20.2001Z",
    fill: "#DAB866"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06394 20.1901L9.56756 18.9556L16.4077 25.6383L15.4645 26.4408L10.0145 21.1185L4.59047 34.2531L3.45148 33.7815L9.06394 20.1901Z",
    fill: "#DAB866"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 39.6889L16.399 30.7852L32.7968 39.6889H0Z",
    fill: "#2D2D2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.399 30.7852L19.3924 39.6889L25.0542 35.4852L16.399 30.7852Z",
    fill: "#3C3C3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3017 15.0617H19.3936V15.7221L18.8297 15.7789L18.6856 15.937V18.5728C18.3298 18.753 17.9665 18.8876 17.5946 18.9765C17.2228 19.0654 16.8398 19.1086 16.447 19.1086C15.4447 19.1086 14.6357 18.7382 14.0201 17.9962C13.4044 17.2555 13.0978 16.2839 13.0978 15.0839C13.0978 13.8765 13.4105 12.9086 14.0385 12.1826C14.6653 11.4567 15.4977 11.0938 16.5357 11.0938C16.8706 11.0938 17.2166 11.1283 17.5725 11.1987C17.9283 11.2678 18.3002 11.3728 18.6881 11.5123V13.6172H17.8705L17.6648 12.2172L17.5035 12.0308C17.3755 11.9937 17.2733 11.9666 17.1969 11.9518C17.1206 11.937 17.0516 11.9296 16.9876 11.9296C16.2993 11.9296 15.7612 12.2123 15.3745 12.7765C14.9867 13.3407 14.7933 14.1221 14.7933 15.1184C14.7933 16.0703 14.9953 16.832 15.3992 17.4049C15.803 17.9765 16.3411 18.2629 17.0147 18.2629H17.1587V15.937L17.0061 15.7789L16.3067 15.7221V15.0617H16.3017Z",
    fill: "#DAB866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandMaster);
export default __webpack_public_path__ + "static/media/GrandMaster.078a6ab9465c8a3ab92aa621410f789e.svg";
export { ForwardRef as ReactComponent };